// extracted by mini-css-extract-plugin
export default {"wrapper":"nwLcFDyNp9TmcZ4wQHTs","collapse":"wNTtHuYYWW0L_STpbtsC","content":"IJbTEoiWnNESP4zvFdxd"};